import React, { useState, useEffect } from 'react';
import { t } from 'l10n';

import {getCookie, setCookie} from 'utils/cookie';

import './CookieConsentBanner.scss'

export default function CookieConsentBanner() {

    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const isBot = /bot|crawl|slurp|spider/i.test(navigator.userAgent)
        const consent = getCookie('cookieConsent')
        if (!consent && !isBot) setVisible(true)
    }, [])

    const setConsent = (value) => {
        let cookieDuration = value === 'accepted' ? 365*24*86400 : 7*24*86400
        setCookie('cookieConsent', value, cookieDuration)
        setVisible(false)
        if (value === 'accepted') window.location.reload()
    }

    if (!visible) return null

    return (
        <div className={'cookieConsentBanner'}>
            <div className={'desktopCookieButton'}>
                <button className="ui-button primary" onClick={() => setConsent('rejected')}>{t('Refuse')}</button>
            </div>
            <div>{t('This site uses cookies for statistical purposes only.')}</div>

            <div className={'desktopCookieButton'}>
                <button className="ui-button primary" onClick={() => setConsent('accepted')}>{t('Accept')}</button>
            </div>
            <div className={'cookieButtons mobileCookieButtons'}>
                <button className="ui-button primary" onClick={() => setConsent('rejected')}>{t('Refuse')}</button>
                <button className="ui-button primary" onClick={() => setConsent('accepted')}>{t('Accept')}</button>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/CookieConsentBanner/CookieConsentBanner.js